<template>
    <div class="os-and-browser-wrapper">
        <div>
            <!--OS:-->
            <div class="os-and-browser">
                <div>
                    <span v-if="getOS === 'Windows'"><windowsIcon /></span>
                    <span v-if="getOS === 'Mac OS'"><macIcon /></span>
                    <span v-if="getOS === 'Linux'"><LinuxIcon /></span>
                    <span v-if="getOS === 'iOS'"><iosIcon /></span>
                    <span v-if="getOS === 'Android'"><androidIcon /></span
                    ><!--Android[-x86]-->
                </div>
                <div>
                    {{ getOS }}
                </div>
            </div>
        </div>
        <div>
            <!--Browser:-->
            <div class="os-and-browser">
                <span v-if="getBrowser === 'Chrome'"> <ChromeIcon /></span>
                <span v-if="getBrowser === 'Safari'"> <SafariIcon /></span>
                <span v-if="getBrowser === 'Edge'"> <EdgeIcon /></span>
                <span v-if="getBrowser === 'Firefox'"> <FirefoxIcon /></span>
                <span v-if="getBrowser === 'Opera'"> <OperaIcon /></span>
                <div>{{ getBrowser }} - {{ getBrowserVersion }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import SafariIcon from "../../components/svg/SafariIcon.vue";
import ChromeIcon from "../../components/svg/ChromeIcon.vue";
import EdgeIcon from "../../components/svg/EdgeIcon.vue";
import OperaIcon from "../../components/svg/OperaIcon.vue";
import FirefoxIcon from "../../components/svg/FirefoxIcon.vue";
import androidIcon from "../../components/svg/AndroidIcon.vue";
import iosIcon from "../../components/svg/iosIcon.vue";
import LinuxIcon from "../../components/svg/LinuxIcon.vue";
import macIcon from "../../components/svg/MacIcon.vue";
import windowsIcon from "../../components/svg/WindowsIcon.vue";
import parser from "ua-parser-js";

export default {
    name: "UserAgentInfo",
    components: {
        SafariIcon,
        ChromeIcon,
        EdgeIcon,
        OperaIcon,
        FirefoxIcon,
        androidIcon,
        iosIcon,
        LinuxIcon,
        macIcon,
        windowsIcon,
    },
    props: {
        visitor: { type: Object, required: true },
    },

    methods: {
        /*detectOS(userAgentString) {
            const ua = parser(userAgentString || "-");
            console.log("UA =>", { userAgentString, ua });
            const osInfo = ua.os || {};

            if (osInfo.name) {
                return osInfo.name;
            } else {
                return "";
            }
        },
        getBrowserVersion(userAgentString, browserName) {
            const browserVersionMatch = userAgentString.match(new RegExp(`${browserName}/([\\d.]+)\\s`));
            return browserVersionMatch ? browserVersionMatch[1] : "";
        },
        detectBrowser(userAgentString) {
            const browserInfo = parser(userAgentString || "-").browser || {};
            let browserName = browserInfo.name || "";
            return browserName;
        },*/
    },
    computed: {
        getOS() {
            if (this.visitor.os.includes("Mac OS")) return "Mac OS";
            else if (this.visitor.os.includes("Windows")) return "Windows";
            else if (this.visitor.os.includes("Linux")) return "Linux";
            else if (this.visitor.os.includes("iOS")) return "iOS";
            else if (this.visitor.os.includes("Android")) return "Android";
            else return this.visitor.os;
        },
        getBrowser() {
            if (this.visitor.browser.includes("Chrome")) return "Chrome";
            else if (this.visitor.browser.includes("Safari")) return "Safari";
            else if (this.visitor.browser.includes("Edge")) return "Edge";
            else if (this.visitor.browser.includes("Firefox")) return "Firefox";
            else if (this.visitor.browser.includes("Opera")) return "Opera";
            else return this.visitor.browser;
        },
        getBrowserVersion() {
            return this.visitor.browser.slice(this.getBrowser.length);
        },
    },
};
</script>

<style scoped>
.os-and-browser {
    display: flex;
    gap: 14px;
}

.os-and-browser-wrapper {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    gap: 3px;
}
</style>
